// extracted by mini-css-extract-plugin
module.exports = {"FeatureCard":"az_nuc","Content":"az_ouc","Title":"az_puc","Subtitle":"az_quc","Spacer":"az_ruc","ImageWrapper":"az_suc","Image":"az_tuc"};